<template>
  <div class="content has_breadcrumb">
    <base-breadcrumb
      :data="[
        {
          routeName: 'announcementGroup',
          name: 'Group announcements'
        },
        {
          routeName: 'announcementGroup',
          name: 'Draft',
          query: {
            status: 'draft'
          }
        },
        {
          name: htmlDecode(announcementdData.title)
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage topType="location" pageType="2" title="Group announcements">
      <div slot="topAppBar"><search></search></div>
      <template v-slot:left>
        <div
          class="mar-l-b"
          v-if="hasPermission('Group Announcements_Full') && activeIndex != 'Create'"
        >
          <gg-create-button @click="openDialogAdd(null)" label="Create announcement" />
        </div>
        <gg-flex-menus :menus="menuDatas" @select="onMenuSelect" :default-active="activeIndex" />
      </template>

      <div class="announcement-inner collapse-list" v-loading="loading">
        <div class="title">
          <div class="tit">{{ htmlDecode(announcementdData.title) }}</div>
          <div class="des" v-if="publishUserData">
            <div class="avatar" v-if="publishUserData.photo">
              <img :src="publishUserData.photo" />
            </div>
            <div class="no" v-else>
              {{
                publishUserData.firstName
                  ? publishUserData.firstName.substring(0, 1).toUpperCase()
                  : '-'
              }}{{
                publishUserData.firstName
                  ? publishUserData.lastName.substring(0, 1).toUpperCase()
                  : '-'
              }}
            </div>
            <div class="name">
              {{ publishUserData.firstName || '' + ' ' + publishUserData.lastName || '' }}
            </div>
            <div class="tag">{{ publishUserData.roleName }}</div>
            <div class="date">saved on {{ momentTime(publishUserData.modifytime) }}</div>
          </div>
          <div class="draft-col" v-if="menuData.length > 0">
            <gg-menu-bar>
              <i class="iconmore_vert-24px iconfont" />
              <template slot="menus">
                <gg-menu-bar-item
                  v-for="(menuitem, key) in menuData"
                  @click="menuClick(menuitem, announcementdData)"
                  :disabled="menuitem === 'Post' ? postDisabled : false"
                  :key="key"
                >
                  <span>{{ typeof menuitem === 'object' ? menuitem.label : menuitem }}</span>
                  <hr v-if="menuitem === 'Post'" class="hr" />
                </gg-menu-bar-item>
              </template>
            </gg-menu-bar>
          </div>
        </div>
        <div class="announcement-inner">
          <div class="draft-right">
            <div class="for-box">
              <el-tree
                :data="locationData"
                node-key="id"
                ref="locationtTree"
                highlight-current
                :props="defaultLocationProps"
              >
              </el-tree>
              <div class="sumCount">
                <div class="sumCount-tit">Selected:</div>
                <div class="sumCount-item">{{ announcementdData.sumSchools }} locations</div>
                <div class="sumCount-item">{{ announcementdData.sumClass }} classes</div>
                <div class="sumCount-item">{{ announcementdData.sumStudents }} students</div>
              </div>
            </div>
          </div>

          <div class="draft-con">
            <div class="edit-box p-box">
              <div class="edit-name">Details</div>

              <div class="edit-editing" v-html="announcementdData.body"></div>

              <div class="file-inner">
                <div class="file-list-inner" v-if="announcementdData">
                  <div
                    class="file-box"
                    @click="viewfile(item)"
                    v-for="(item, index) in announcementdData.fileList"
                    :key="index"
                  >
                    <div class="file-head">
                      <pdf
                        style="width: 103px; height: 72px; text-align: center"
                        class="pdf-preview"
                        v-if="returnFileFormat(item.filePath) === 'pdf'"
                        :id="item.filePath"
                        :page="1"
                        :src="item.filePath"
                      />
                      <el-image
                        v-else
                        style="width: 103px; height: 72px"
                        :src="item.filePath"
                        fit="cover"
                      >
                      </el-image>
                    </div>
                    <div class="file-body">
                      <div class="file-name">File name: {{ item.fileName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="response-inner p-box"
              v-if="
                announcementdData.questionContent?.instruction ||
                announcementdData.questionContent?.dueDate ||
                announcementdData.questionContent?.options.length > 0
              "
            >
              <div class="response-col">
                <div class="response-name">
                  Response
                  <span class="date" v-if="announcementdData.questionContent.dueDate"
                    >Due on
                    {{ responsesMomentTime(announcementdData.questionContent.dueDate) }}</span
                  >
                </div>

                <div class="response-option-inner">
                  <div class="response-tit">
                    {{ htmlDecode(announcementdData.questionContent?.instruction) }}
                  </div>
                  <div class="response-option">
                    <md-radio
                      v-for="(item, index) in announcementdData.questionContent.options"
                      :key="index"
                      :disabled="true"
                      :label="item.label"
                      v-model="responseRadio"
                      class="md-primary"
                      :value="index"
                      >{{ item.label }}</md-radio
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GgPage>
    <Snackbar :visible.sync="snackbarData.visible" :content="snackbarData.content" />

    <gg-Dialog
      width="580px"
      v-if="isDialogShow"
      :visible.sync="isDialogShow"
      title="Post announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">
        You have selected {{ announcementdData.sumSchools }} location{{
          announcementdData.sumSchools > 1 ? 's' : ''
        }}, {{ announcementdData.sumClass }} class{{ announcementdData.sumClass > 1 ? 'es' : '' }},
        and {{ announcementdData.sumStudents }} student{{
          announcementdData.sumStudents > 1 ? 's' : ''
        }}. Once the announcement is posted, it will be visible to all parents of the selected
        classes.
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isDialogShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="updateAnnouncementStatus">Post</gg-submit-button>
      </span>
    </gg-Dialog>

    <gg-Dialog
      width="580px"
      :visible.sync="isDelectShow"
      title="Delete announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">Once deleted, you will not be able to recover the data.</div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isDelectShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="removeAnnouncement">Delete</gg-submit-button>
      </span>
    </gg-Dialog>

    <Snackbar :visible.sync="loadingShow" :content="loadingText" />
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import search from '../modules/search'
import moment from 'moment'
import { Ajax } from '@/common'
import { mapState } from 'vuex'
import { hasPermission } from './../utils/utils.js'
export default {
  components: {
    pdf,
    search
  },
  computed: {
    ...mapState({
      breadcrumb: (state) => state.breadcrumb,
      user: (state) => state.user
    }),
    postDisabled() {
      const item = this.announcementdData
      let disabled =
        !item.title ||
        item.title?.length > 255 ||
        !item.body ||
        !item.schoolClassJson ||
        !this.questionOptionsSw(item) ||
        this.zzStr(item.body).length > 5000
      // 注意括号：|| 链要先于三目运算合并进 disabled，
      // 否则前置校验结果会被 `options.length < 2` 覆盖
      disabled =
        disabled ||
        (item.questionContent?.instruction ||
        item.questionContent?.dueDate ||
        item.questionContent?.options.length > 0
          ? item.questionContent?.options.length < 2
          : false)
      return disabled
    }
  },
  data() {
    return {
      loading: false,
      defaultLocationProps: {
        children: 'children',
        label: 'label'
      },
      locationData: [],
      publishUserData: null,
      saveobj: {},
      rootPath: process.env.VUE_APP_fileBasePath,
      isDelectShow: false,
      isDialogShow: false,
      status: {
        DRAFT: 0,
        POSTED: 1,
        ARCHIVE: 2
      },
      radioDisabled: false,
      loadingText: '',
      loadingShow: false,
      announcementdData: {},
      // announcementdData 归属的路由身份（getBy/{id} 请求身份，Ruling R18）
      announcementdDataRouteId: '',
      // 破坏性写确认态的行主键快照：身份切换时作废，绝不能跨身份确认
      delId: '',
      id: '',
      responseRadio: '',
      menuData: [],
      activeIndex: 'draft',
      fileProgress: true,
      amount: 50,
      selectedDate: null,
      module: {
        title: '',
        moduleType: '',
        moduleName: ''
      },
      disabledAddoption: true,
      tableData: [],
      // isAllowed: true,
      oldVal: '',
      snackbar: { isShow: false, content: '' },
      responseBoxShow: true,
      content: '',
      classselectList: [],
      classList: [],
      menuDatas: [
        {
          name: 'Draft',
          key: 'draft',
          active: true
        },
        {
          name: 'Posted',
          key: 'post',
          active: true
        },
        {
          name: 'Archived',
          key: 'archive',
          active: true
        }
      ],
      snackbarData: {
        visible: false,
        content: ''
      }
    }
  },
  created() {
    if (hasPermission('Group Announcements_Full')) {
      this.menuData = ['Post', 'Edit', 'Delete']
    }

    if (this.$route.params.id) {
      this.id = this.$route.params.id || ''
      this.getAnnoucementDetail()
    }
  },
  watch: {
    // 详情页被 A→B 复用：路由 id 变化按新身份重取，过期响应按请求身份丢弃
    '$route.params.id'(id) {
      if (!id) {
        this.$message.error('Missing announcement')
        this.$router.replace('/announcementGroup')
        return
      }
      // 身份切换作废上一身份的确认态、对话框与点击时刻快照：不得跨身份确认（防写错行）
      this.isDialogShow = false
      this.isDelectShow = false
      this.saveobj = {}
      this.delId = ''
      this.id = id
      this.getAnnoucementDetail()
    }
  },
  mounted() {},
  methods: {
    hasPermission,
    getLocationsData(schoolClassMap) {
      let data = {
        staffId: this.user.userId
      }
      Ajax.get('/usermanage/class/listAllClassV1', data).then((res) => {
        if (res.code === '0000') {
          this.locationLoading = false
          this.locationData = res.data
            .filter((item) => !!Object.keys(schoolClassMap).find((shoolId) => shoolId === item.id))
            .map((item) => {
              let obj = {
                label: item.name,
                id: item.id,
                children: item.schoolClassList
                  .filter((classItem) =>
                    schoolClassMap[item.id].find((classId) => classId === classItem.id)
                  )
                  .map((classItem) => {
                    return {
                      label: classItem.className,
                      id: classItem.id
                    }
                  })
              }
              return obj
            })
        }
      })
    },
    getAnnoucementDetail() {
      this.loading = true
      let data = {
        id: this.user.userId
      }
      // 请求身份：响应回来时按当前路由 id 判定，路由已变则丢弃过期响应（本页无 watch 重取）
      const reqId = this.$route.params.id
      Ajax.get(`/announcement/group-announcements/getBy/${this.id}`, data)
        .then((res) => {
          if (reqId !== this.$route.params.id) return
          // 后端 getById 无记录返回空 DTO（questionContent 等全空）：视同缺记录，
          // 不 normalize（JSON.parse(undefined) 会炸，null 会炸模板层层解引用）
          if (res.code !== '0000' || !res.data || res.data.questionContent == null) {
            this._missingAnnouncement()
            return
          }
          this.announcementdData = res.data
          this.announcementdData.body = this.htmlDecode(this.announcementdData.body)
          // this.announcementdData.addFile = res.data.addFile.split(",");
          this.announcementdData.questionContent = JSON.parse(res.data.questionContent)
          const options = this.announcementdData.questionContent.options || []
          console.log('getAnnoucementDetail', this.announcementdData)
          for (let i = 0; i < options.length; i++) {
            if (options[i].value === '1') {
              this.responseRadio = options[i].label
              break
            }
          }
          // 记录该 DTO 归属的路由身份：破坏性 id 仅在与当前路由身份一致时可信（Ruling R18）
          this.announcementdDataRouteId = reqId
          this.getRolename(res.data.publishUser)
          this.getLocationsData(res.data.schoolClassMap)
          // classIds 依赖 detail DTO，detail 落地后再取（此前 created 并行取会读到 undefined）
          this.getClass()
          this.loading = false
        })
        .catch(() => {
          if (reqId !== this.$route.params.id) return
          this._missingAnnouncement()
        })
    },
    // 详情建立失败（404/空 DTO/网络错误）：提示并回列表，不落半套数据（同 otherPosted 口径）
    _missingAnnouncement() {
      this.loading = false
      this.$message.error('Missing announcement')
      this.$router.replace('/announcementGroup')
    },

    // 写操作的行主键（R18 口径）：仅当 announcementdData 归属当前路由身份时可信；
    // 响应未到/缺参返回 null，绝不回落路由键或滞留 DTO
    _verifiedRowId() {
      const routeId = this.$route.params.id
      if (!routeId || this.announcementdDataRouteId !== routeId) return null
      return (this.announcementdData && this.announcementdData.id) || null
    },

    _refuseWrite() {
      this.snackbarData.content = 'Announcement data is not ready yet, please try again'
      this.snackbarData.visible = true
    },
    getRolename(id) {
      let data = {
        id: id
      }
      Ajax.get('/usermanage/staff/user/selectStaffByUserId', data).then((res) => {
        if (res.code === '0000') {
          this.publishUserData = res.data
        }
      })
    },
    questionOptionsSw() {
      let optionsSw = true,
        optionsInstructionSw = true,
        questionContent = this.announcementdData.questionContent

      for (let i = 0; i < questionContent.options.length; i++) {
        if (questionContent.options[i].label.length > 100) {
          optionsSw = false
          break
        }
      }
      if (questionContent.instruction.length > 255) {
        optionsInstructionSw = false
      }
      return optionsSw && optionsInstructionSw
    },

    responsesMomentTime(date) {
      return moment.utc(date).local().format('DD/MM/YYYY')
    },
    formatHtml(html) {
      return html.replace(/<p[^>]*>\s*<\/p>/g, '<p><br></p>')
    },
    htmlDecode(text) {
      var temp = document.createElement('div')
      temp.innerHTML = text
      var output = temp.innerText || temp.textContent
      temp = null
      return output
    },

    zzStr(str) {
      return str.replace(/(<([^>]+)>)/gi, '').replace(/[\r\n]/g, '')
    },

    returnFileFormat(url) {
      console.log('returnFileFormat', url)
      let reg = /\.([0-9a-z]+)(?:[\?#]|$)/i
      // 无扩展名/空值时 match 为 null：判空避免 `match(reg)[1]` 崩溃
      return ((url || '').match(reg) || [])[1] || ''
    },

    viewfile(file) {
      const needPrint = 1
      // 模板 file-list 行是 fileName/filePath，旧入参形是 name/url：两形统一取值
      const fileUrl = file.filePath || file.url || ''
      const fileName = file.fileName || file.name || ''
      let reg = /\.([0-9a-z]+)(?:[\?#]|$)/i
      let fileFormat = (fileName.match(reg) || [])[1] || ''

      if (fileFormat === 'pdf') {
        let routeData = this.$router.resolve({
          path: '/testFileView',
          query: { url: fileUrl, name: fileName, needPrint: needPrint }
        })
        window.open(routeData.href, '_blank')
      } else {
        let routeData = this.$router.resolve({
          path: '/testFileView',
          query: { imgUrl: fileUrl, name: fileName, needPrint: needPrint }
        })
        window.open(routeData.href, '_blank')
      }
    },

    menuClick(e, item) {
      // 破坏性写入口先核实行归属：加载窗口/身份不符拒绝（Ruling R18 口径）
      const rowId = this._verifiedRowId()
      if (!rowId) {
        this._refuseWrite()
        return
      }
      if (e === 'Post') {
        this.delId = rowId
        this.isDialogShow = true
        this.saveobj = {
          title: item.title,
          classid: item.classIds
        }
      }
      if (e === 'Delete') {
        this.delId = rowId
        this.isDelectShow = true
      }
      if (e === 'Edit') {
        this.$router.push({
          name: 'createAnnouncementGroup',
          query: { editid: rowId }
        })
      }
    },

    removeAnnouncement() {
      // 确认时再核实：行主键必须仍是确认态开启时核实的那一行
      const rowId = this._verifiedRowId()
      if (!rowId || rowId !== this.delId) {
        this._refuseWrite()
        return
      }
      let data = {}
      data.id = rowId
      this.isDelectShow = false

      Ajax.post('/announcement/announcements/remove/' + rowId, data)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingText = 'Draft has been deleted'
            this.loadingShow = true
            setTimeout(() => {
              this.$router.push({ name: 'announcementGroup' })
            }, 1200)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    updateAnnouncementStatus() {
      // 确认时再核实：行主键必须仍是确认态开启时核实的那一行
      const rowId = this._verifiedRowId()
      if (!rowId || rowId !== this.delId) {
        this._refuseWrite()
        return
      }
      let data = {}
      data.id = rowId
      data.status = 'post'
      data.publishUser = this.user.userId
      data.title = this.saveobj.title
      data.classId = this.saveobj.classid
      this.isDialogShow = false

      Ajax.post('/announcement/group-announcements/updateStatusByIdV1', data)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingText = 'Announcement has been posted'
            this.loadingShow = true

            setTimeout(() => {
              this.$router.push({
                name: 'announcementGroup',
                query: { status: 'post' }
              })
            }, 1200)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    momentTime(date) {
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    },

    getClassInfo() {
      let id = this.id,
        data = {}
      data.userId = id
      Ajax.get('/announcement/announcements/getRecipientsByIdV1/' + id, data)
        .then((res) => {
          if (res.code === '0000') {
            this.classselectList = res.data
            for (let i = 0; i < this.classselectList.length; i++) {
              this.classselectList[i].ai = this.classselectList[i].className
                ? this.classselectList[i].className.substring(0, 2).toUpperCase()
                : '-'
            }

            for (let i = 0; i < res.data.length; i++) {
              for (let j = 0; j < this.classList.length; j++) {
                if (res.data[i].classId === this.classList[j].id) {
                  this.classList[j].select = true
                  break
                }
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    getClass() {
      // 请求身份：A→B 复用时丢弃过期响应
      const reqId = this.$route.params.id
      // detail 未回时 classIds 不存在：判空避免 for…of undefined 崩溃（审计 D）
      const classIds = (this.announcementdData && this.announcementdData.classIds) || []
      Ajax.get(
        '/usermanage/class/listByClassV1?staffId=' +
          this.user.userId +
          '&locationId=' +
          this.user.locationId
      ).then((res) => {
        if (reqId !== this.$route.params.id) return
        let tempdata = [],
          temparr = {}

        for (let item of res.data || []) {
          for (let classid of classIds) {
            if (item.id === classid) {
              temparr = item
              temparr.select = true
              temparr.ai =
                item.className.indexOf(' ') > -1
                  ? (
                      item.className.split(' ')[0].substring(0, 1).toUpperCase() +
                      item.className.split(' ')[1].substring(0, 1)
                    ).toUpperCase()
                  : item.className.substring(0, 1).toUpperCase()
              tempdata.push(temparr)
            }
          }
        }

        this.classList = tempdata
      })
    },

    // getClass() {
    //   let formData = new FormData();
    //   formData.append("staffId", this.user.userId);
    //   formData.append("locationId", this.user.locationId);

    //   Ajax.post(
    //     "/usermanage/class/selectByStaffId",
    //     formData, {
    //       headers: { "Content-Type": "multipart/form-data" }
    //     })
    //     .then((res) => {
    //       let tempdata = [], temparr, classData = [], key = '', idArr = []
    //       for(let item in res.data) {
    //         key = item
    //         for(let item_ of res.data[key]) {
    //           if(!idArr.includes(item_.classId)) {
    //             idArr.push(item_.classId)
    //             classData.push(item_)
    //           }
    //         }
    //       }

    //       for(let item of classData) {
    //         for(let classid of this.announcementdData.classIds) {
    //           if(item.classId === classid) {
    //             temparr = item
    //             temparr.select = true
    //             temparr.ai =
    //               item.className.indexOf(' ') > -1 ?
    //               (item.className.split(' ')[0].substring(0, 1).toUpperCase() + item.className.split(' ')[1].substring(0, 1)).toUpperCase() :
    //               item.className.substring(0, 1).toUpperCase();
    //             tempdata.push(temparr)
    //           }
    //         }
    //       }

    //       this.classList = tempdata
    //     });
    // },

    toStudentListPage() {},

    openDialogAdd() {
      this.$router.push({ name: 'createAnnouncementGroup' })
    },

    onMenuSelect(key, item) {
      this.activeIndex = key
      this.$router.replace({
        name: 'announcementGroup',
        query: { status: key }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.collapse-list {
  /deep/.el-loading-mask {
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
    .el-loading-spinner {
      position: absolute;
    }
  }
  .title {
    position: relative;
    padding-left: 8px;
    padding-bottom: 26px;
    border-bottom: 1px solid #e3e3e3;
    color: #202124;
    font-size: 22px;
    font-weight: 600;
    font-family: OpenSans-Bold;

    .tit {
      margin-bottom: 5px;
      font-size: 20px;
      font-family: Open Sans;
      font-weight: 600;
      line-height: 27px;
      padding-right: 70px;
      word-wrap: break-word;
    }

    .des {
      .no {
        display: inline-block;
        margin-right: 8px;
        width: 24px;
        height: 24px;
        background: #b4b4b4;
        border-radius: 50%;
        line-height: 24px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        font-family: Open Sans;
        font-weight: 600;
      }

      .avatar {
        margin-right: 8px;
        display: inline-block;
        width: 24px;
        height: 24px;
        vertical-align: middle;

        img {
          display: block;
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }

      .name {
        margin-right: 8px;
        display: inline-block;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        line-height: 19px;
        color: #202124;
        vertical-align: middle;
      }

      .tag {
        margin-right: 8px;
        display: inline-block;
        padding: 4px 9px;
        height: 20px;
        font-family: Roboto;
        line-height: 12px;
        font-weight: 400;
        background: #e0e0e0;
        border-radius: 10px;
        font-size: 12px;
        vertical-align: middle;
      }

      .date {
        margin-right: 8px;
        display: inline-block;
        font-size: 12px;
        font-family: Roboto;
        font-weight: 400;
        line-height: 16px;
        color: #b4b4b4;
      }
    }

    .draft-col {
      position: absolute;
      right: 20px;
      top: 0;
    }
  }
}

.announcement-inner {
  font-family: 'Roboto';
  padding-top: 20px;

  .draft-con {
    background: #fff;
    overflow: hidden;

    .edit-box {
      border: 1px solid #e0e0e0;
      border-radius: 13px;

      .edit-name {
        padding-left: 20px;
        line-height: 68px;
        border-bottom: 1px solid #e0e0e0;
        color: #5f6368;
        font-size: 20px;
        font-family: 'opensans-semibold';
      }

      .edit-tit {
        padding: 0 20px;

        .md-field.md-theme-default:after {
          border-bottom: 1px solid #e0e0e0;
        }
      }

      .edit-editing {
        padding: 20px;
        font-size: 14px;
        font-family: Roboto;
        font-weight: 500;
        line-height: 19px;
        color: #202124;
        word-break: break-all;
        p {
          min-height: 14px;
        }
      }

      .file-inner {
        padding: 0 20px 20px 20px;

        .add-file-btn {
          width: 104px;
          height: 32px;
          line-height: 32px;
          background-color: #fff;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          cursor: pointer;
          font-size: 13px;
          color: #5f6368;

          .add-file-icon {
            margin: 0 5px 0 10px;
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }

          &:hover {
            background-color: #e8f0fe;
          }
        }

        .file-list-inner {
          .file-box {
            margin-top: 10px;
            position: relative;
            height: 72px;
            line-height: 72px;
            background: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;

            .file-head {
              float: left;
              width: 103px;
              height: 72px;

              img {
                display: block;
                width: 103px;
                height: 72px;
              }
            }

            .file-body {
              padding: 0 20px;
              font-size: 12px;
              color: #202124;
              overflow: hidden;

              .delete {
                position: absolute;
                right: 20px;
                top: 22px;
                width: 24px;
                height: 24px;
                cursor: pointer;

                img {
                  display: block;
                  width: 24px;
                  height: 24px;
                }

                &:hover {
                  opacity: 0.7;
                }
              }
            }
          }
        }
      }
    }

    .response-inner {
      margin-bottom: 20px;

      .response-option-inner {
        padding: 20px;

        .response-tit {
          margin-bottom: 20px;
          font-size: 14px;
          font-family: Roboto;
          font-weight: 400;
          line-height: 19px;
          color: #202124;
        }

        .response-option {
          line-height: 19px;
        }
      }

      .add-response-btn {
        margin: 20px 0;
        color: #1a73e8;
        font-size: 13px;
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }

      .response-col {
        margin-top: 20px;
        border: 1px solid #e0e0e0;
        border-radius: 13px;

        .response-name {
          position: relative;
          padding-left: 20px;
          line-height: 68px;
          border-bottom: 1px solid #e0e0e0;
          color: #5f6368;
          font-size: 20px;
          font-family: 'Open Sans';

          .date {
            margin-left: 10px;
            font-size: 12px;
            font-family: Roboto;
            font-weight: 400;
            line-height: 16px;
            color: #b4b4b4;
          }

          .delete {
            position: absolute;
            right: 20px;
            top: 22px;
            width: 24px;
            height: 24px;
            cursor: pointer;

            img {
              display: block;
              width: 24px;
              height: 24px;
            }

            &:hover {
              opacity: 0.7;
            }
          }
        }

        .response-info {
          .response-date {
            float: right;
            position: relative;
            margin: 0 20px 0 80px;
            width: 220px;

            .calendar-today {
              position: absolute;
              right: 0;
              top: 21px;
              width: 24px;
              height: 24px;
            }
          }

          .response-tit {
            padding: 0 0 0 20px;
            overflow: hidden;

            .md-field.md-theme-default:after {
              border-bottom: 1px solid #e0e0e0;
            }
          }
        }
      }
    }
  }

  .draft-right {
    float: right;
    padding-left: 20px;
    width: 364px;
    background: #fff;

    .cancel {
      position: fixed;
      right: 80px;
      bottom: 120px;

      .tit {
        float: left;
        margin-right: 20px;
        font-size: 13px;
        color: #5f6368;
        line-height: 33px;
      }

      .con {
        float: left;

        .el-button {
          width: 92px;
          padding: 0 32px 0 0;
          text-align: center;
          line-height: 35px;

          .el-tooltip {
            display: block;
            border-right: 1px solid #dcdfe6;
            font-weight: normal;
            color: #1a73e8;
          }

          .el-tooltip.disabled {
            color: #b4b4b4;
            font-weight: bold;
          }

          .iconfont {
            position: absolute;
            right: 10px;
            top: 0;
          }

          * {
            font-weight: bold;
            font-size: 13px !important;
          }
        }
      }
    }

    .for-box {
      padding: 20px;
      width: 342px;
      border: 1px solid #e0e0e0;
      border-radius: 13px;
      max-height: 739px;
      min-height: 68px;
      overflow-y: auto;
      /deep/.el-loading-mask {
        position: absolute;
        background: rgba(255, 255, 255, 0.8);
        .el-loading-spinner {
          position: absolute;
        }
      }
      .sumCount {
        margin-top: 20px;
        font-family: OpenSans;
        line-height: 1.4;
        font-size: 14px;
        color: #5f6368;
        &-tit {
          font-family: OpenSans-Bold;
        }
      }
      // .for-name {
      //   position: relative;
      //   padding-left: 20px;
      //   line-height: 68px;
      //   color: #5f6368;
      //   font-size: 20px;
      //   font-family: "opensans-semibold";
      // }

      // .for-dropdown-bg {
      //   position: fixed;
      //   top: 0;
      //   right: 0;
      //   bottom: 0;
      //   left: 0;
      //   z-index: 999;
      //   overflow: hidden;
      // }

      // .for-dropdown {
      //   position: relative;
      //   z-index: 1000;
      //   margin: auto 20px;
      //   padding: 0 20px;
      //   height: 32px;
      //   line-height: 32px;
      //   border: 1px solid #e0e0e0;
      //   border-radius: 4px;
      //   font-size: 14px;
      //   color: #b4b4b4;
      //   cursor: pointer;

      //   &.hover {
      //     .dropdown-list {
      //       display: block;
      //     }
      //   }

      //   .arrow-drop {
      //     position: absolute;
      //     right: 4px;
      //     top: 4px;
      //     width: 20px;
      //     height: 20px;
      //   }

      //   .dropdown-list {
      //     display: none;
      //     position: absolute;
      //     left: 0;
      //     top: 32px;
      //     padding: 0 2px 0 0;
      //     width: 298px;
      //     background: #fff;
      //     box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      //     border-radius: 4px;

      //     .dropdown-list-inner {
      //       padding: 8px 0;
      //       max-height: 156px;
      //       overflow-y: auto;

      //       &::-webkit-scrollbar {
      //         width: 4px;
      //         border-radius: 4px;
      //       }

      //       &::-webkit-scrollbar-track {
      //         background-color: #fff;
      //       }

      //       .select-all {
      //         padding-left: 16px;
      //         line-height: 28px;
      //         font-size: 14px;
      //         color: #202124;

      //         .el-checkbox {
      //           width: 100%;
      //           color: #202124;
      //         }

      //         &:hover {
      //           background-color: #eee;
      //         }
      //       }

      //       .class-list {
      //         padding: 0;

      //         li {
      //           .el-checkbox {
      //             width: 100%;
      //           }

      //           &:hover {
      //             background-color: #eee;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }

      // .class-list {
      //   padding: 7px 0 0 0;

      //   li {
      //     padding: 0 0 0 16px;
      //     line-height: 28px;
      //     font-size: 14px;
      //     color: #202124;

      //     .no {
      //       display: inline-block;
      //       margin-right: 8px;
      //       width: 20px;
      //       height: 20px;
      //       background: #7e7e7e;
      //       border-radius: 50%;
      //       line-height: 20px;
      //       text-align: center;
      //       color: #fff;
      //       font-size: 11px;
      //       margin-top: -2px;
      //       vertical-align: middle;
      //     }

      //     .name {
      //       display: inline-block;
      //       font-size: 14px;
      //       color: #202124;
      //     }
      //   }
      // }

      // .for-select-list {
      //   padding: 0 20px 0 20px;
      //   width: 317px;
      //   max-height: 150px;
      //   overflow-y: auto;

      //   &::-webkit-scrollbar {
      //     width: 4px;
      //     border-radius: 4px;
      //   }

      //   &::-webkit-scrollbar-track {
      //     background-color: #fff;
      //   }
      // }
    }
  }
}

// 选项
.el-table {
  /deep/tbody tr:hover {
    .isDisplay {
      display: inherit !important;
    }
  }
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fff;
}
/deep/.section-main {
  margin: 0;
  max-height: calc(100vh - 112px);
  overflow-y: auto;
}
/deep/.el-table td {
  padding: 3px 0;
}
.list-table {
  .not-allowed {
    cursor: not-allowed !important;
    color: #cbcbcb !important;
  }
  .iconfont {
    font-size: 24px;
    line-height: 24px;
    margin-left: 16px;
    cursor: pointer;
  }
  .rowName {
    position: relative;
    padding-left: 40px;
    font-family: Roboto;
    font-size: 14px;
    color: #202124;

    .md-input {
      font-size: 14px;
    }

    .my-handle {
      position: absolute;
      cursor: grab;
      left: 0;
      transform: translateY(-50%);
      top: 50%;
    }

    .editName {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }
  .cell {
    .action {
      position: absolute;
      top: 12px;
      right: 0;
    }
  }

  .el-table .cell {
    overflow: inherit;
  }
  .md-field {
    margin-bottom: 0;
    padding-top: 0;
    min-height: 32px;
  }
  .md-field.md-invalid {
    margin-bottom: 20px;
  }
  .md-field .md-error {
    bottom: -13px;
  }
}

.wraper {
  padding: 20px 0 20px 10px;

  .append {
    .base-button {
      font-family: Roboto;
      font-size: 13px;
      color: #1a73e8;
    }
  }
}

.file-progress {
  position: fixed;
  left: 50%;
  bottom: 0;
  margin-left: -170px;
  padding: 15px;
  width: 340px;
  height: 80px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 14px;

  dt {
    margin-bottom: 5px;
    display: block;
    font-weight: bold;
  }

  .stop {
    position: absolute;
    right: 15px;
    top: 15px;
    padding: 6px 12px;

    &:hover {
      background: #1a73e8;
      color: #fff;
    }
  }

  .progress {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8px;
    border-radius: 0 0 4px 4px;
  }
}

.menu_bar {
  margin-top: 9px;
  width: 40px;
  height: 40px;
  line-height: inherit;

  .drop_down_menus {
    padding: 0;
  }
}

.menu_bar .menu_bar_button:hover {
  background: none;
}

.p-box {
  &:last-child {
    margin-bottom: 112px !important;
  }
}
</style>
<style lang="less">
.edit-editing {
  p {
    min-height: 14px;
  }
}
</style>
